import Event from '@/models/Event';

export default {
  event: new Event(),
  events: [],
};
